import ProjectGroup from '../project-group';

/**
 * Create the action
 */

const { thunk, request, success, error } = ProjectGroup.store((data, fetch) => {
    // Prepare request
    let formData = new FormData();
    ['project_id', 'user_id']
        .map(key => data[key] !== undefined ? formData.append(key, data[key]) : null);
    
    return fetch.post(`/project-groups`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
